/**
 * useItemSpaceScope — the current space as lib/itemSpaceScope.ts reads it.
 *
 * Used by the desktop item list, the phone item list and the Pipeline Health
 * report, which each pass it to scopeItemsToSpace and describeSpaceScope, so a
 * count on the report and the list it opens agree on a laptop and on a phone.
 * Subscribes to the two space-store primitives directly so a component
 * re-renders when bootstrap fills mySpaces, even when currentSpaceId was
 * already restored from storage and does not change.
 */

import { useMemo } from 'react';
import { useSpaceStore } from '../../stores/prioritization/spaceStore';
import { resolveItemSpaceScope, type ItemSpaceScope } from '../../lib/itemSpaceScope';

export function useItemSpaceScope(): ItemSpaceScope | null {
  const currentSpaceId = useSpaceStore((s) => s.currentSpaceId);
  const mySpaces = useSpaceStore((s) => s.mySpaces);
  return useMemo(() => resolveItemSpaceScope(currentSpaceId, mySpaces), [currentSpaceId, mySpaces]);
}
